export default __webpack_public_path__ + "2065e4d7f8827e852eb1f913d1a7b1b4.svg";